module.exports = __webpack_public_path__ + "static/CentralParkMobileDescription-67ed9e28732a0032d37ec720cc28ed51.jpg";